import { render } from "./Contact.vue?vue&type=template&id=5753e326"
import script from "./Contact.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Contact.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script